import { render, staticRenderFns } from "./button-type-editor.vue?vue&type=template&id=5f9a5a3c&scoped=true"
import script from "./button-type-editor.vue?vue&type=script&lang=js"
export * from "./button-type-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f9a5a3c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f9a5a3c')) {
      api.createRecord('5f9a5a3c', component.options)
    } else {
      api.reload('5f9a5a3c', component.options)
    }
    module.hot.accept("./button-type-editor.vue?vue&type=template&id=5f9a5a3c&scoped=true", function () {
      api.rerender('5f9a5a3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/field-button/button-type-editor.vue"
export default component.exports